export function scrollToFirstError () {
  document.querySelector("[data-invalid=\"1\"]")?.scrollIntoView({
    behavior: "smooth",
    block: "center",
  })
}
